<template>
    <div class="v-alert quill">
        <header><p>{{ header }}</p><div class="x" @click="exit"></div></header>
        <div class="quill-container">
            <div id="editor"></div>
            <div class="btns">
                <p class="btn" style="display: none;" @click="$emit('emit',{ t: 'quill', action: 'showPreview' })">preview</p>
                <p class="btn" @click="save">save</p>
            </div>
        </div>
    </div>
</template>

<script>

import Alert from '@/utils/Alert.js'
import Quill from 'quill'
import UploadFile from '../utils/UploadFile.js';
import postMinify from '../utils/postMinify.js';

export default {
    props: ['item'],
    data () {
        return {
            html: '',
            updatedHtml: '',
            header: 'Edit Page'
        }
    },
    created () {
        if ( this.item.header ) {
            this.header = this.item.header
        }
        console.log('created this.item',this.item);
    },
    mounted () {
        this.updatedHtml = this.html = this.item.html;

        var style = document.querySelector('head #quill');
        if ( !style ) {
            style = document.createElement('link');
            style.setAttribute('href','https://cdn.quilljs.com/1.0.0/quill.snow.css');
            style.setAttribute('id','quill');
            style.setAttribute('rel','stylesheet');
            document.head.appendChild(style);
        }
        this.initQuill();
    },
    methods: {
        initQuill () {
            /*
            var Font = Quill.import('formats/font');
                Font.whitelist = ['inconsolata', 'roboto', 'mirza', 'arial'];
                Quill.register(Font,true);

                console.log('Font',Font);
            */
            
            var quill = new Quill(this.$el.querySelector('#editor'),{
                modules: {
                    //toolbar: '#toolbar-container'
                    toolbar: [
                        [{ 'font': [] }],
                        [{ header: [1, 2, 3, 4, false] }],
                        ['bold', 'italic', 'underline'],
                        [{ 'align': null} , {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
                        [{ 'color': ['#FF0000','#00FF00','#0000FF','#000000','#FFFFFF'] },{ 'background': ['#FF0000','#00FF00','#0000FF','#000000','#FFFFFF'] }],
                        [{ 'indent': '-1'}, { 'indent': '+1' }],
                        ['link'],
                        ['image'],
                        ['video']
                    ]
                },
                theme: 'snow',
            });
            quill.getModule('toolbar').addHandler('image',() => { 
                var range = quill.getSelection();
                UploadFile(result => {
                    postMinify(result.result,resp => {
                        if ( resp.size ) return console.log('resp.size',resp.size);
                        if ( resp.progress ) { return console.log('progress',resp.progress) }
                        if ( resp.url ) {
                            quill.insertEmbed(range.index, 'image', resp.url);
                        }
                    })
                })                
            });
            quill.on('editor-change',() => this.updateHTML(quill.scrollingContainer.innerHTML));
            quill.scrollingContainer.innerHTML = this.item.html
        },
        updateHTML ( HTML ) {
            this.updatedHtml = HTML;
            this.$emit('emit',{ t: 'quill', action: 'updateHTML', HTML });
        },
        imageHandler ( image, cB ) {
            console.log('imageHandler',image);
            cB(image);
        },
        exit () {
            if ( this.updatedHtml != this.item.html ) {
                return Alert.yesno('Exit without saving Changes ?',yes => {
                    yes && this.$emit('exit');
                })
            }
            this.$emit('emit',{ action: 'exit' });
        },
        save () {
            if ( this.updatedHtml == this.item.html ) return this.$emit('exit')
            this.item.save({ _id: this.item._id, html: this.updatedHtml });
        }
    }
}

</script>

<style lang="scss">
.v-alert.quill {
    width: calc(50% + 45px);
    margin-left: 240px;
    padding-bottom: 5px;
    top: 70px;
    z-index: 50000;
    position: fixed;
    header p { text-align: left; font-size: 20px; float: left; width: 100%; }
    
    .quill-container {
        min-height: 290px;
        top: 5px;
        position: relative;
        float: left;
        width: 100%;
        #editor {
            width: calc(100% - 10px);
            height: 570px;
            margin: 5px;
            margin-top: 0px;
            strong { font-weight: bold !important; }
            strong * { font-weight: bold !important; }
            strong * * { font-weight: bold !important; }
        }
        .ql-toolbar {
            width: calc(100% - 10px);
            margin: 0px 5px;

        }
    }
}
  /* Set dropdown font-families */
  
  #toolbar-container .ql-font span[data-label="Sans Serif"]::before {
    font-family: "Sans Serif";
  }
  
  #toolbar-container .ql-font span[data-label="Inconsolata"]::before {
    font-family: "Inconsolata";
  }
  
  #toolbar-container .ql-font span[data-label="Roboto"]::before {
    font-family: "Roboto";
  }
  
  #toolbar-container .ql-font span[data-label="Mirza"]::before {
    font-family: "Mirza";
  }
  
  #toolbar-container .ql-font span[data-label="Arial"]::before {
    font-family: "Arial";
  }
  /* Set content font-families */
  
  .ql-font-inconsolata {
    font-family: "Inconsolata";
  }
  
  .ql-font-roboto {
    font-family: "Roboto";
  }
  
  .ql-font-mirza {
    font-family: "Mirza";
  }
  
  .ql-font-arial {
    font-family: "Arial";
  }
</style>